// extracted by mini-css-extract-plugin
export default {"link":"HR-z","disabled":"IR-z"};